import { render, staticRenderFns } from "./JournalProductInTransit.vue?vue&type=template&id=276ae17a"
import script from "./JournalProductInTransit.vue?vue&type=script&lang=js"
export * from "./JournalProductInTransit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports